<template>
  <div class="daily-item-p">
    <div class="item-title-p">
      <img :src="src" alt />
      <span>{{title}}</span>
    </div>
    <div class="item-content-p">
      <pre>{{text}}</pre>
    </div>
    <div class="item-img-p" v-if="imgList.length > 0">
      <img
        :src="img"
        alt
        v-for="(img,index) of imgList"
        :key="index"
        @click="showImg(imgList,index)"
      />
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/imgTextItem/imgTextItem.scss"

export default {
  name: 'imgTextItem',
  data() {
    return {

    }
  },
  props:{
    src:{
      type:String,
      default:""
    },
    title:{
      type:String,
      default:""
    },
    text:{
      type:String,
      default:""
    },
    imgList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  methods:{
    showImg(imgList,index){
      this.$emit("openPopImgList",imgList,index)
    }
  }
}
</script>
